// import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

	/** @ngInject */
	constructor(
		$state,
		CompanyUser,
		ConfirmDeleteModal,
		SharedAccountsService,
		Alert
	) {
		this.$state = $state;
		this.CompanyUser = CompanyUser;
		this.ConfirmDeleteModal = ConfirmDeleteModal;
		this.SharedAccountsService =  SharedAccountsService;
		this.Alert = Alert;
	}

	$onInit() {
		this.labels$.get().then((labels) => this.labels = labels);
		this.selectedUnshareLabels=[];
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);

		this.$sharedLabels =  JSON.parse(JSON.stringify(this.sharedLabels));
        this.newUserIdentifier = null;
        this.userIdentifier = null;
        this.st = new SmartTable();
        this.stLabels = new SmartTable();
	}

	identifyUser() {
		this.message = null;
		this.userIdentifier = this.newUserIdentifier;

		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.userIdentifier)
		}).$promise
			.then((response) => {

				this.successResult = true;
				this.showVerification = false;
				this.companyUser = response;

				this.message = 'groups_users.user_found';
			})
			.catch((error) => {
				this.successResult = false;
				this.companyUser = null;

				this.showVerification = this.enableVerification && !this.successResult
					&& $rootScope.emailPattern.test(this.userIdentifier);

				if (error.status == 404) {
					this.message = 'groups_users.user_not_found';
				} else {
					this.message = response.data.message;
				}
			})

	}

	getSharingTypeDisplayName(sharingType) {
        if (sharingType == 'INDIVIDUAL_AND_TEAM') {
            return 'INDIVIDUAL & TEAM';
        } else {
            return sharingType;
        }
    }

	share(saaspassId) {

		var param = {
			companyId: this.companyId,
			id: this.sharedAccountId,
			saaspassId: saaspassId
		}
		if(this.isNote){
			this.SharedAccountsService.shareNoteWithSaaspassUser(param, {}).$promise.then((response) => {
                    this.successMessageAndReloadNoteUsers('shared_accounts.messages.share_account');
                }).catch((error) => {});
		} else {
			this.SharedAccountsService.shareCompanyServiceAccounts(param, {}).$promise.then((response) => {
				this.successMessageAndReloadUsers('shared_accounts.messages.share_account');
			}).catch((error) => {});
		}


	}

	unshare(saaspassId) {
		//this.type = 'SINGLE';
		this.saaspassId = saaspassId;
		this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
			.then(() => {
				var param = {
					companyId: this.companyId,
					id: this.sharedAccountId,
					saaspassId: this.saaspassId
				}
				if (this.isNote) {
					this.SharedAccountsService.unshareUserNote(param, {}).$promise.then((response) => {
                    	this.successMessageAndReloadNoteUsers('shared_accounts.messages.unshare_account');
               		}).catch((error) => { });
				} else {
					this.SharedAccountsService.unshareCompanyServiceAccounts(param, {}).$promise.then((response) => {
						this.successMessageAndReloadUsers('shared_accounts.messages.unshare_account');
					}).catch((error) => { });
				}

			});
	}
	unshareSelected(){
          //this.type = 'ALL';
          this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
                    .then(() => {
						var param = {
                        companyId: this.companyId,
                        id : this.sharedAccountId
                    }         
                    
                    var data = this.getSelectedSaaspassIds();
						if (this.isNote) {
							this.SharedAccountsService.unshareNoteWithUsers(param, data).$promise.then((response) => {
								this.successMessageAndReloadNoteUsers('shared_accounts.messages.unshare_account');

							}).catch((error) => {
							});
						} else {
							this.SharedAccountsService.unshareSelectedCompanyServiceAccounts(param, data).$promise.then((response) => {
								this.successMessageAndReloadUsers('shared_accounts.messages.unshare_account');
							}).catch((error) => {
							});
						}
			});
    }

	cancleSearch() {
		this.userIdentifier = null;
		this.successResult = null;
		this.showVerification = false;
		this.companyUser = null;
		this.message = null;
		this.newUserIdentifier = null;
	}
	
	getSelectedSaaspassIds() {
         return this.st.selectedItems.map((user) => user.saaspassId);
    }
	
	clickLabel(label) {
		if (label.name === "ALL_USERS") {
			this.sharedLabels.map((item) => {
				if (item.name !== "ALL_USERS") {
					item.isShared = false;
				}
			});
		}
		this.selectedLabels = this.sharedLabels.filter((item) => item.isShared);
	}
	clickUnshareLabel(label) {
		var indexOfLabel = this.selectedUnshareLabels.indexOf(label);
		if (indexOfLabel >= 0) {
			this.selectedUnshareLabels.splice(indexOfLabel, 1)
		} else {
			if (label.name === "ALL_USERS") {
				this.selectedUnshareLabels = [];
			}
			this.selectedUnshareLabels.push(label);
		}
	}
	isCheckboxDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedLabels.length==1) && (this.selectedLabels[0].name==="ALL_USERS");
		return isIt;
	}
	isCheckboxUnshareDisabled(label) {
		var isIt = (label.name !== "ALL_USERS") && (this.selectedUnshareLabels.length==1) && (this.selectedUnshareLabels[0].name==="ALL_USERS");
		return isIt;
	}
	
	isCheckedLabel(label){
		var indexOfLabel=this.selectedLabels.indexOf(label);
		return indexOfLabel >= 0;
	}
	
	isCheckedUnshareLabel(label){
		var indexOfLabel=this.selectedUnshareLabels.indexOf(label);
		return indexOfLabel >= 0;
	}

	sharedLabelsNotModified() {
		return angular.equals(this.$sharedLabels, this.sharedLabels);
	}
	
	shareWithLabels(){
		var param = {
			companyId: this.companyId,
			id: this.sharedAccountId
		}
		if (this.isNote) {
			 this.SharedAccountsService.updateCompanyNoteLabels(param, this.sharedLabels).$promise.then((response) => {
                    this.successMessageAndReloadNoteUsers('shared_accounts.messages.share_account');
                }).catch((error) => { });
		} else {
			 this.SharedAccountsService.updateServiceAccountLabels(param, this.sharedLabels).$promise.then((response) => {
				this.successMessageAndReloadUsers('shared_accounts.messages.share_account');
			}).catch((error) => { });
		}
	}
	
	successMessageAndReloadUsers(key) {
		this.$state.go('.', {}, {reload: '.'});
		this.Alert('success', key);
		
	}
	successMessageAndReloadNoteUsers(key) {
		this.$state.go('.', {}, {reload: '.'});
		this.Alert('success', key);
		
	}
	
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/share.controller.js